<template>
  <v-navigation-drawer
    v-model="innerValue"
    @input="mudancaStatus"
    right
    :width="width"
    nav
    v-bind="$attrs"
    temporary
    class="px-2"
  >

    <v-card :loading="loading" light elevation="0">
      
      <v-card-title class="text-h5 font-weight-medium">
        <v-icon
          large
          color="grey darken-2"
          class="mr-2"
        >
          fa-filter
        </v-icon>
        FILTRO AVANÇADO
      </v-card-title>
      <v-card-text>
        <slot name="default"></slot>
      </v-card-text>
    </v-card>
    
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'SGPDrawerComponent',

  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },

    width: {
      type: [String, Number],
      required: false,
      default: 300
    },

    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data () {
    return {
      innerValue: false
    }
  },

  methods: {
    mudancaStatus (val) {
      this.$emit('input', val)
    }
  },

  watch: {
    value (val) {
      this.innerValue = val
    }
  }
}
</script>